"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var MomentField_1 = require("./MomentField");
var BoundHelper_1 = require("@twii/common-ui/lib/component/BoundHelper");
var BoundMomentField = /** @class */ (function (_super) {
    __extends(BoundMomentField, _super);
    function BoundMomentField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onChanged = function (value) {
            BoundHelper_1.setBoundValue(_this.props, value);
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }
    BoundMomentField.prototype.render = function () {
        var value = BoundHelper_1.getBoundValue(this.props);
        return React.createElement(MomentField_1.MomentField, __assign({}, this.props, { onChange: this._onChanged, value: value }));
    };
    BoundMomentField = __decorate([
        mobx_react_1.observer
    ], BoundMomentField);
    return BoundMomentField;
}(React.Component));
exports.BoundMomentField = BoundMomentField;
